/* eslint-disable prefer-template */
export const buildVendorSearchLabel = (vendorCode, vendorName, sapVendorCode) => (
  [vendorCode, vendorName, sapVendorCode]
    .filter((v) => v != null && String(v).trim() !== '')
    .map((v) => String(v).trim())
    .join(' ')
);

const formatDropdownOptionsVendor = (array, labelField, valueField, extraLabel) => {
  if (array?.length > 0) {
    return array?.map((item) => {
      let label = '';
      if (item?.[labelField] && item?.[extraLabel]) {
        label = item?.[extraLabel] + ' - ' + item?.[labelField];
      } else {
        label = item?.[labelField];
      }
      return ({
        ...item,
        label,
        value: item?.[valueField],
        searchLabel: buildVendorSearchLabel(
          item?.[extraLabel],
          item?.[labelField],
          item?.sapVendorCode
        )
      });
    });
  }
  return [];
};

export default formatDropdownOptionsVendor;
